/*
  Libraries page for FullStack.cash
*/

import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Container, Row, Col, Card, Button } from 'react-bootstrap'
import libraries from '../assets/images/libraries.jpg'

function Libraries () {
  return (
    <>
      <Helmet>
        <title>JS Libraries | FullStack.cash</title>
      </Helmet>

      <Container className='py-5'>
        <Row className='mb-5'>
          <Col md={6}>
            <h2>Libraries: Supercharge Your Application</h2>
            <p>
              JavaScript{' '}
              <a href='https://npmjs.com' target='_blank' rel='noreferrer'>
                npm libraries
              </a>{' '}
              act as middleware 'glue' to tie the front-end application to the
              back-end infrastructure. They also allow developers to
              supercharge their applications with new features, and then share
              those features with other developers and applications.
            </p>
            <p>
              <a
                href='https://github.com/Permissionless-Software-Foundation/bch-js'
                target='_blank'
                rel='noreferrer'
              >
                bch-js
              </a>{' '}
              is a low-level JavaScript library for generating custom Bitcoin Cash
              transactions. <a href='https://www.npmjs.com/package/minimal-slp-wallet' target='_blank' rel='noreferrer'>minimal-slp-wallet</a> is
              high-level JavaScript library for executing common wallet features.
              FullStack.cash maintains several additional
              libraries for specific blockchain use cases. This page lists the
              most popular and important libraries we maintain.
            </p>
          </Col>
          <Col md={6}>
            <img src={libraries} alt='Libraries' className='img-fluid' />
          </Col>
        </Row>

        <Row className='g-4'>
          <Col md={6}>
            <Card className='h-100'>
              <Card.Body>
                <Card.Title><strong>bch-js</strong></Card.Title>
                <Card.Text>
                  bch-js is the primary JavaScript library maintained by
                  FullStack.cash. It provides a convenient way to leverage the
                  bch-api REST API, and it also includes many handy utilities for
                  generating wallets and addresses, signing messages, doing
                  encryption, and many other valuable features. All other
                  libraries on this page depend on this base library.
                </Card.Text>
                <Button
                  href='https://www.npmjs.com/package/@psf/bch-js'
                  target='_blank'
                  rel='noreferrer'
                  variant='outline-primary'
                >
                  Library
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className='h-100'>
              <Card.Body>
                <Card.Title><strong>jwt-bch-lib</strong></Card.Title>
                <Card.Text>
                  A library for handling FullStack.cash JWT tokens. This library
                  enables your app to automatically renew JWT tokens as-needed.
                  This allows your app to 'just work', so long as your account has
                  credit to pay for new JWT tokens.
                </Card.Text>
                <Button
                  href='https://www.npmjs.com/package/jwt-bch-lib'
                  target='_blank'
                  rel='noreferrer'
                  variant='outline-primary'
                >
                  Library
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Libraries
